import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { ZoneMasterTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ZoneMasterTheme>;
const css = baseCss as ThemedCssFunction<ZoneMasterTheme>;

export const ZoneMaster = styled.div`
  width: 100%;
  height: 100%;
`;
